/**
 * One §F6 home card — the mockup's `.tool-card`, under Part H's metadata.
 *
 * A `<button>` rather than the mockup's `<div data-tool>`: it is the control that opens a
 * tool, so it should be reachable by keyboard and announce itself as a button. The tile
 * colour and the icon are Part H's (`lib/analysis.TOOLS`); the tag, name and description
 * are the mockup's copy, through `t()` (§F12).
 */
import { useTranslation } from 'react-i18next';

import { Icon } from '../../lib/icons';
import type { ToolCard as ToolCardSpec } from '../../lib/analysis';

export interface ToolCardProps {
  card: ToolCardSpec;
  onOpen: (id: ToolCardSpec['id']) => void;
}

export function ToolCard({ card, onOpen }: ToolCardProps) {
  const { t } = useTranslation();
  return (
    <button type="button" className="tool-card" data-tool={card.id} onClick={() => onOpen(card.id)}>
      <span className="tool-ico" style={{ background: card.color }} aria-hidden="true">
        <Icon name={card.icon} size={17} />
      </span>
      <span style={{ flex: 1 }}>
        <span className="tag">{t(`analysis.tool.${card.id}.tag`)}</span>
        <b>{t(`analysis.tool.${card.id}.name`)}</b>
        <p>{t(`analysis.tool.${card.id}.desc`)}</p>
      </span>
    </button>
  );
}

export default ToolCard;
